import React from "react";

// Inline "couldn't load" panel with an optional retry, used when a page's first fetch fails.
const ErrorState = ({ title = "Unable to load this page", message, onRetry, className = "" }) => (
  <div className={`container py-4 ${className}`}>
    <div className="card border-0 shadow-sm mx-auto" style={{ borderRadius: 14, maxWidth: 560 }}>
      <div className="card-body text-center p-4">
        <div className="fs-1 mb-2" aria-hidden="true">⚠️</div>
        <h5 className="mb-2">{title}</h5>
        {message && <p className="text-muted mb-3">{message}</p>}
        <div className="d-flex justify-content-center gap-2">
          {onRetry && (
            <button type="button" className="btn btn-dark px-4" onClick={onRetry}>
              Try again
            </button>
          )}
          <button type="button" className="btn btn-outline-secondary" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default ErrorState;
